// 支付和登录过程保留当前页，避免窗口变化中断操作。
export function getCustomResponsiveRoute(route, width) {
    if (route.path === '/phonePay' || route.path === '/phoneLogin') {
        return {preserve: true}
    }
    const path = width < 900
        ? ({'/custom': '/phoneCustom', '/user': '/phoneUser'})[route.path]
        : ({'/phoneCustom': '/custom'})[route.path]
    if (path) return {path, query: route.query}
    if (route.path === '/phoneCustom' || route.path === '/custom') return {preserve: true}
    return null
}
